import { Schemas } from '~/api/gen'
import { SeeMoreButton } from '~/components/elements/SeeMoreButton'
import { Coordinate3ColumnList } from '~/components/modules/CoordinatesList/Coordinate3ColumnList/Coordinate3ColumnList'
import { useSearchCoordinates } from '~/features/shared/search/hooks/useSearchCoordinates'
import { useIsDesktop } from '~/hooks/useMediaQuery'

const PAGE_NO = 1
const PAGE_SIZE = 9
const DISPLAY_COUNT_FOR_DESKTOP = 6

type Props = {
  itemId: number
}

type ViewProps = {
  coordinates: Schemas.coordinate_search_v2[]
  seeMoreUrl: string
  totalCount: number
  displayCount: number
}

export const CoordinateListByItemIdView: React.FC<ViewProps> = ({
  coordinates,
  seeMoreUrl,
  totalCount,
  displayCount,
}) => (
  <div className="pb-[18px] pt-[14px] xl:relative xl:w-[556px] xl:pb-[33px]">
    <div className="relative">
      <h2 className="pb-4 pl-4 text-[14px] font-bold leading-none xl:pb-[15px] xl:pl-0 xl:text-[13px]">
        着用コーディネート<span className="pl-1">({totalCount})</span>
      </h2>
      {totalCount > displayCount && (
        <p className="absolute right-[18px] top-[-1px] leading-none xl:hidden">
          <a
            href={seeMoreUrl}
            className="text-[14px] font-bold text-blue-500"
            aria-label="着用コーディネートをすべて見る"
          >
            すべて見る
          </a>
        </p>
      )}
    </div>
    <Coordinate3ColumnList coordinates={coordinates.slice(0, displayCount)} />
    {totalCount > displayCount && (
      <div className="hidden xl:relative xl:block xl:h-[56px]">
        <div className="xl:absolute xl:bottom-[-13px] xl:right-0">
          <SeeMoreButton
            href={seeMoreUrl}
            aria-label="着用コーディネートをもっと見る"
          />
        </div>
      </div>
    )}
  </div>
)

export const CoordinateListByItemId: React.FC<Props> = ({ itemId }) => {
  const { data } = useSearchCoordinates({
    item_id: itemId,
    pageno: PAGE_NO,
    pagesize: PAGE_SIZE,
  })

  const coordinates = data?.coordinates ?? []
  const totalCount = data?.total_count ?? 0
  const isDesktop = useIsDesktop()
  if (totalCount > 0) {
    return (
      <CoordinateListByItemIdView
        coordinates={coordinates}
        seeMoreUrl={`/coordinate/?item_id=${itemId}`}
        totalCount={totalCount}
        displayCount={isDesktop ? DISPLAY_COUNT_FOR_DESKTOP : PAGE_SIZE}
      />
    )
  }
  return null
}
